import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {ReactiveFormsModule, FormControl} from '@angular/forms';
import {NachrichtenFilter} from '../../core/model/nachrichten-filter';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-postfach-filter',
  standalone: true,
  imports: [ReactiveFormsModule, I18NextPipe],
  templateUrl: './postfach-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PostfachFilterComponent {

  @Input() selectedFilter = NachrichtenFilter.ALL;
  @Output() filterSelected = new EventEmitter<NachrichtenFilter>();


  isVisible = signal(false);
  aaChecked = new FormControl(true, {nonNullable: true});
  jcChecked = new FormControl(true, {nonNullable: true});

  toggleDiv() {
    this.isVisible.set(!this.isVisible());
  }

  onCheckboxChange(changedCheckbox: string) {
    // Ensure at least one checkbox is always checked
    if (!this.aaChecked.value && !this.jcChecked.value) {
      changedCheckbox === 'aa' ? this.aaChecked.setValue(true) : this.jcChecked.setValue(true);
    }

    // Emit the appropriate filter based on the state of the checkboxes
    let filter: NachrichtenFilter;
    if (this.aaChecked.value && this.jcChecked.value) {
      filter = NachrichtenFilter.ALL;
    } else if (this.aaChecked.value) {
      filter = NachrichtenFilter.AA;
    } else {
      filter = NachrichtenFilter.JC;
    }

    this.filterSelected.emit(filter);
  }

}



